import CustomTextBox from "app/components/atoms/customTextBox";
import CustomRadio from "app/components/atoms/customRadio";
import CustomSelect from "app/components/atoms/customSelect";

export const mentorshipAvailabilityUiSchema = {
  "ui:title": "",
  ctpt_optedintosaiceconnect: {
    "ui:widget": (props) => {
      return <CustomSelect getProps={props} />;
    },
  },
  ctpt_availabledaytime: {
    "ui:widget": (props) => {
      return <CustomRadio getProps={props} />;
    },
  },
  ctpt_availableevenings: {
    "ui:widget": (props) => {
      return <CustomRadio getProps={props} />;
    },
  },
  ctpt_availableonweekdays: {
    "ui:widget": (props) => {
      return <CustomRadio getProps={props} />;
    },
  },
  ctpt_availableonweekends: {
    "ui:widget": (props) => {
      return <CustomRadio getProps={props} />;
    },
  },
  ctpt_availabilitynotes: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_connectmentee: {
    "ui:widget": (props) => {
      return <CustomRadio getProps={props} />;
    },
  },
};

